import React from "react";

type FeatureItem = {
  title: string;
  description: string;
  icon: string;
  color?: string;
};

type FeatureSection = {
  heading: string;
  items: FeatureItem[];
};

type FeatureSectionsProps = {
  sections: FeatureSection[];
};

const sections: FeatureSection[] = [
  {
    heading: "For Employers",
    items: [
      { title: "Job Posting Platform", description: "Create customized job listings tailored to your requirements.", icon: "bi bi-briefcase", color: "text-primary" },
      { title: "Screening Tools", description: "Use built-in filters to shortlist candidates based on skills, qualifications, and experience.", icon: "bi bi-funnel", color: "text-primary" },
      { title: "Candidate Management", description: "Track applications, send messages, and schedule interviews directly on the platform.", icon: "bi bi-people", color: "text-primary" },
      { title: "Hiring Support", description: "Access resources and guidance for every stage of the recruitment process.", icon: "bi bi-check2-circle", color: "text-primary" },
    ],
  },
  {
    heading: "For Job Seekers",
    items: [
      { title: "Upload CVs", description: "Showcase your skills and experience to employers worldwide.", icon: "bi bi-upload", color: "text-success" },
      { title: "Direct Applications", description: "Apply to jobs instantly and track your progress.", icon: "bi bi-send", color: "text-success" },
      { title: "Profile Visibility", description: "Get noticed by recruiters actively searching for talent.", icon: "bi bi-eye", color: "text-success" },
      { title: "Career Resources", description: "Stay updated with industry insights, tips, and opportunities.", icon: "bi bi-journal-text", color: "text-success" },
    ],
  },
  {
    heading: "Additional Features",
    items: [
      { title: "Communication Hub", description: "Employers and candidates can connect seamlessly through integrated messaging.", icon: "bi bi-chat-dots", color: "text-warning" },
      { title: "Newsletter Subscription", description: "Receive the latest updates on job openings, industry trends, and platform enhancements.", icon: "bi bi-envelope", color: "text-warning" },
      { title: "Secure & Reliable", description: "Built with modern technology to ensure data privacy and smooth performance.", icon: "bi bi-shield-check", color: "text-warning" },
    ],
  },
];

const FeatureSections: React.FC<FeatureSectionsProps> = ({ sections }) => {
  return (
    <>
      {sections.map((section, idx) => (
        <div key={idx} className="mb-5" data-aos="fade-up" data-aos-delay="100">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <h2 className="mb-4">{section.heading}</h2>
              <ul className="list-unstyled">
                {section.items.map((item, i) => (
                  <li
                    key={i}
                    className="d-flex align-items-start mb-3 p-3 shadow-sm rounded"
                  >
                    <i
                      className={`${item.icon} ${item.color || "text-primary"} fs-4 me-3`}
                    ></i>
                    <div>
                      <strong>{item.title}:</strong> {item.description}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

function ServicesPage() {

  return (
    <>
      <section id="services" className="contact section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Services</h2>
        </div>

        {/* Feature Sections */}
        <FeatureSections sections={sections} />
      </section>
    </>
  )
}

export default ServicesPage;
